import styles from './Home.module.scss'
import NavBar from "../../components/NavBar";
import { useEffect, useState } from 'react';
import { IProcesso } from '../../interfaces/processo.interface';
import http from '../../components/http';
import Loading from '../../components/Loading';
import { useNavigate } from 'react-router-dom';
import CardPedido from '../../components/Cards/CardPedido';
import useFetchPedidos from '../../hooks/pedidos/useFetchPedidos';
import fundoVale from '../../assets/img/fundoVale.jpg'

export default function Home() {
    const [processos, setProcessos] = useState<IProcesso[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { pedidos } = useFetchPedidos();

    const navigate = useNavigate();

    const buscarDados = async () => {
        try {
            setLoading(true);
            const response = await http.get('/processos');
            setProcessos(response.data);
        } catch (error) {
            console.log('Error ao carregar processos! ' + error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        buscarDados();
    }, []);

    return (
        <main className={styles.principal}>
            <NavBar />

            {loading && <Loading />}

            {!loading &&
                <section className={styles.sectionProcessos}>
                    <h1>Bem Vindo!</h1>
                    <h2>Estes são seus pedidos em andamento: </h2>
                    <div className={styles.containerProcessos}>
                        {pedidos.map((pedido) => (
                            <CardPedido
                                pedido={pedido}
                                detalhes={() => ''}
                                excluir={() => ''}
                            />
                        ))}
                    </div>
                </section>
            }

            <img style={{ width: 150, height: 60, margin: 20 }} src={fundoVale} alt="" />
        </main>
    )
}